import React from 'react';
import { useSignature } from '../../contexts/SignatureContext';

interface ControlArchetypeProps {
  title: string;
  subtitle?: string;
  badgeText?: string;
  icon?: React.ReactNode;
  headerActions?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * ARQUÉTIPO 1: CONTROL
 * Destinado a painéis de gestão, KPIs, alertas, acompanhamento executivo e visões gerais.
 */
export const ControlArchetype: React.FC<ControlArchetypeProps> = ({
  title,
  subtitle,
  badgeText,
  icon,
  headerActions,
  children,
}) => {
  const { colors, densities } = useSignature();

  return (
    <div
      className="flex-1 overflow-y-auto scrollbar-standard"
      style={{
        backgroundColor: colors.bgApp,
        padding: `${densities.paddingMainPx}px`,
        color: colors.textPrimary,
      }}
    >
      <div className="max-w-7xl mx-auto space-y-6">
        {/* Header do Arquétipo CONTROL */}
        <header className="flex flex-wrap items-center justify-between gap-4 pb-4 border-b" style={{ borderColor: colors.border }}>
          <div className="flex items-center gap-3">
            {icon && (
              <div
                className="p-2.5 rounded-2xl border shadow-xs"
                style={{
                  backgroundColor: colors.primaryLight,
                  color: colors.primary,
                  borderColor: colors.border,
                }}
              >
                {icon}
              </div>
            )}
            <div>
              <h1 className="text-xl sm:text-2xl font-bold tracking-tight" style={{ color: colors.textPrimary }}>
                {title}
              </h1>
              {subtitle && (
                <p className="text-xs sm:text-sm mt-0.5" style={{ color: colors.textSecondary }}>
                  {subtitle}
                </p>
              )}
            </div>
          </div>

          <div className="flex items-center gap-3">
            {badgeText && (
              <span
                className="px-3 py-1 rounded-full text-xs font-bold font-mono border"
                style={{
                  backgroundColor: colors.primaryLight,
                  color: colors.primary,
                  borderColor: colors.border,
                }}
              >
                {badgeText}
              </span>
            )}
            {headerActions}
          </div>
        </header>

        {/* Conteúdo Principal */}
        <main className="space-y-6">{children}</main>
      </div>
    </div>
  );
};
